import React from "react";
import { Link } from "react-router-dom";

// components

import Navbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";

export default function Python() {
  return (
    <>
      <Navbar transparent />
      <section class="text-gray-600 body-font" id="python">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-col text-center w-full mb-20">
            <h2 class="text-xs text-indigo-500 tracking-widest font-medium title-font mb-1">
              Hire The Best Python Developers
            </h2>
            <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-red-500">
              Hire The Best Python Developers At Dave's Brother Technology
            </h1>
            <p class="lg:w-2/3 mx-auto leading-relaxed text-base">
              Kfrom Dave's  and give a push to your startup or business by
              developing cutting edge Angular.js apps. Powering millions of
              devices across the globe, we offer advanced Angular.js application
              development services.
            </p>
          </div>
          <div class="flex flex-col text-center w-full mb-20">
            <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
              Why Choose Dave's  For Python Development?
            </h1>
          </div>
          <div class="flex flex-wrap">
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
                24x7 Unwavering Support
              </h2>
              <p class="leading-relaxed text-base mb-4">
                End to end Python development services . Complete Search Engine
                Optimization.
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
                Flexible Hiring
              </h2>
              <p class="leading-relaxed text-base mb-4">
                Scalability and advanced security.
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
                Save Time & Money
              </h2>
              <p class="leading-relaxed text-base mb-4">
                Guarantee of high performance and speed
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
                Customer Is King!
              </h2>
              <p class="leading-relaxed text-base mb-4">
                Mobile-friendly web apps. Comprehensive analysis and transparent
                communication.
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section class="text-gray-600 body-font">
        <div class="flex flex-col text-center w-full mb-20">
          <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
            Benefits Of Choosing Python For Your Company
          </h1>
        </div>
        <div class="container px-5 py-24 mx-auto flex flex-wrap">
          <div class="lg:w-1/2 w-full mb-10 lg:mb-0 rounded-lg overflow-hidden">
            <img
              alt="feature"
              class="object-cover object-center mt-20-px h-300 w-300"
              src="https://engineerbabu.com/img/new/flutter/flutter_benefit.png"
            />
          </div>
          <div class="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp; Powerful Technology Stack{" "}
                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                  Python is highly readable as it mandates indentation and is
                  dynamically typed. It allows you to create backend code using
                  robust web development frameworks such as Django & Flask
                </p>
              </div>
            </div>
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp;Cross-Platform Friendly
                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                  Python is compatible with all major platforms
                </p>
              </div>
            </div>
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp; Increased Performance
                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                  It is a scalable language which makes it simple to handle
                  tasks of all sizes
                </p>
              </div>
            </div>
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp;Flexibility & Scalability
                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                  Python is used to create prototypes and minimum viable
                  products in a very short time Known for its open-source
                  frameworks and tools
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
